import { AfterViewInit, Component } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, FilterDescriptor, State } from '@progress/kendo-data-query';

import { IColumns } from 'bi-interfaces';
import { ICardFilter } from 'bi-interfaces/lib/interfaces/ICardFilter';
import { BIModulesService } from '../../bi-modules.service';

@Component({
  selector: 'bi-card-filter',
  templateUrl: './bi-card-filter.component.html',
  styleUrls: ['./bi-card-filter.component.scss']
})
export class BiCardFilterComponent implements ICardFilter, AfterViewInit {

  constructor(public myBiser:BIModulesService,public mymess:MessageService)
  {
    //this.myBiser.setDir()
    this.mymess.notify(this.myBiser.getDir())

  }
  state !: State;
  data !: { value: CompositeFilterDescriptor, Columns: any, Dialog: any }

  ngOnInit(): void {
    if(!this.data.value){
      this.data.value = {logic: 'and', filters: []}
    }
  }

  ngAfterViewInit(): void {
    if (!this.data.value)
      this.data.value = { logic: 'and', filters: [] };
  }

  onFilterChange(value: CompositeFilterDescriptor) {
    this.state = { filter: value }
  }

  editorValueChange(value: any, currentItem: FilterDescriptor, filterValue: CompositeFilterDescriptor): void {
    currentItem.value = value;
    this.state = { filter: filterValue }
  }

  lookupValueChange(value: any, key: any, currentItem: FilterDescriptor, filterValue: CompositeFilterDescriptor): void {
    currentItem.value = value[key];
    this.state = { filter: filterValue }
  }

  RadioValueChange(value: any, currentItem: FilterDescriptor, filterValue: CompositeFilterDescriptor): void {
    currentItem.value = value.value;
    this.state = { filter: filterValue }
  }

  OnOk() {
    this.data.Dialog.DialogReturnSubject.next({
      state: this.state
    });
  }

  OnCancel() { }

}